/**
 * Tres Commas campaigns (GET /tres-commas/campaigns — every page, same shape as
 * GET /voluum/campaigns, read by the same fetchCampaignList as useCampaigns).
 * Feeds the Traffic link dialog's campaign picker and the Campaigns page's own
 * list (useCampaignsPageCampaigns); never merged into useAllCampaigns, which
 * also feeds the tag-rule pickers. 503 while tres-commas is not configured.
 * For Media Devoted | Created By Ciro Autiero
 */

import { useQuery } from '@tanstack/react-query';

import { fetchCampaignList } from '@/hooks/voluum/campaign-list';
import type { Campaign } from '@/hooks/voluum/useVoluum';

import { tresCommasKeys } from './keys';

/** A tres-commas campaign: the Voluum campaign shape, without a Voluum/Binom `provider` tag. */
export type TresCommasCampaign = Omit<Campaign, 'provider'>;

export function useTresCommasCampaigns(enabled = true) {
  return useQuery({
    queryKey: tresCommasKeys.campaigns(),
    queryFn: () => fetchCampaignList<TresCommasCampaign>('/tres-commas/campaigns'),
    enabled,
    staleTime: 60_000,
    retry: 1,
  });
}
